import { m } from "@/paraglide/messages";
import { useRafInterval } from "ahooks";

import { toast } from "sonner";

const CURRENT_APP_VERSION =
	import.meta.env.VITE_APP_CURRENT_VERSION || "UNKNOWN_VERSION";

export function useVersionCheck() {
	useRafInterval(() => {
		const checkAppVersion = async () => {
			try {
				const response = await fetch(`/version.txt?${new Date().getTime()}`, {
					cache: "no-store",
				});
				const latestVersionFileContent = (await response.text()).trim();

				const isServerForceRefresh =
					latestVersionFileContent.includes("-FORCE-REFRESH");
				const latestServerBaseVersion = latestVersionFileContent.replace(
					"-FORCE-REFRESH",
					"",
				);

				if (
					isServerForceRefresh &&
					latestServerBaseVersion !== CURRENT_APP_VERSION
				) {
					if (
						location.pathname.includes("/edit/") ||
						location.pathname.includes("/story/")
					) {
						console.log("skip version check");
						return;
					}
					console.log(
						`version check:${latestServerBaseVersion} vs ${CURRENT_APP_VERSION}`,
					);
					toast.info(m.version_check_new_version_detected());
					setTimeout(() => {
						window.location.reload();
					}, 1200);
				}
			} catch (error) {
				console.error("Failed to check app version:", error);
			}
		};

		checkAppVersion();
	}, 1000 * 60);
}
